'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Vortex = function (_React$Component) {
  (0, _inherits3.default)(Vortex, _React$Component);

  function Vortex() {
    (0, _classCallCheck3.default)(this, Vortex);
    return (0, _possibleConstructorReturn3.default)(this, (Vortex.__proto__ || Object.getPrototypeOf(Vortex)).apply(this, arguments));
  }

  (0, _createClass3.default)(Vortex, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_base2.default, (0, _extends3.default)({
        typeClassName: 'BurgerVortex'
      }, this.props), _react2.default.createElement(_style2.default, {
        styleId: '3285278599',
        css: '.BurgerVortex .BurgerInner{-webkit-transition-duration:0.2s;transition-duration:0.2s;-webkit-transition-timing-function:cubic-bezier(0.19,1,0.22,1);transition-timing-function:cubic-bezier(0.19,1,0.22,1);}.BurgerVortex .BurgerInner:before,.BurgerVortex .BurgerInner:after{-webkit-transition-duration:0s;transition-duration:0s;-webkit-transition-delay:0.1s;transition-delay:0.1s;-webkit-transition-timing-function:linear;transition-timing-function:linear;}.BurgerVortex .BurgerInner:before{-webkit-transition-property:top,opacity;transition-property:top,opacity;}.BurgerVortex .BurgerInner:after{-webkit-transition-property:bottom,-webkit-transform;-webkit-transition-property:bottom,transform;transition-property:bottom,transform;}.BurgerVortex.BurgerActive .BurgerInner{-webkit-transform:rotate(765deg);-ms-transform:rotate(765deg);transform:rotate(765deg);-webkit-transition-timing-function:cubic-bezier(0.19,1,0.22,1);transition-timing-function:cubic-bezier(0.19,1,0.22,1);}.BurgerVortex.BurgerActive .BurgerInner:before,.BurgerVortex.BurgerActive .BurgerInner:after{-webkit-transition-delay:0s;transition-delay:0s;}.BurgerVortex.BurgerActive .BurgerInner:before{top:0;opacity:0;}.BurgerVortex.BurgerActive .BurgerInner:after{bottom:0;-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg);}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=../../src/types/vortex.js */'
      }));
    }
  }]);
  return Vortex;
}(_react2.default.Component);

exports.default = Vortex;
Vortex.defaultProps = _defaultProps2.default;
module.exports = exports['default'];